import { Spacing, Text, Title } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { platform } from 'reactApp/appHelpers/configHelpers';
import { QUOTA_PAGE_BASE_URL } from 'reactApp/constants/magicIdentificators';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getOverQuota } from 'reactApp/modules/userQuota/userQuota.selectors';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

import styles from './MobileDisableDownloadPopup.css';

const sendRadar = (action: 'show' | 'click' | 'close' = 'show') => {
    sendXray(['overq_dwnld_touchtip', action]);

    sendDwh({
        eventCategory: 'tooltip',
        action,
        dwhData: {
            name: 'mnz_overquota_cleaner',
            platform,
        },
        sendImmediately: true,
    });
};

type Props = {
    onClose?: () => void;
};

export const MobileDisableDownloadPopup = memo<Props>(({ onClose }) => {
    const dispatch = useDispatch();
    const scrollRef = useRef<HTMLDivElement>(null);
    const quota = useSelector(getOverQuota);

    useEffect(sendRadar, []);

    const handleClose = useCallback(() => {
        sendRadar('close');
        onClose?.();
    }, [onClose]);

    const handleClick = useCallback(() => {
        sendRadar('click');

        dispatch(historyPush({ id: QUOTA_PAGE_BASE_URL }));

        onClose?.();
    }, [onClose]);

    return (
        <MobileDialog
            id="cleaner-download-disable-ab"
            onClose={handleClose}
            closeOnDimmerClick
            topmost
            scrollRef={scrollRef}
            mod="base"
            contextPadding="zero"
        >
            <div ref={scrollRef} className={styles.root}>
                <Title level="2">Скачать файлы пока нельзя</Title>
                <Spacing size={12} />
                <Text className={styles.text}>
                    Облако переполнено на <span className={styles.space}>{quota.value}</span>. Увеличьте место с подпиской Mail Space или
                    удалите ненужные файлы
                </Text>
                <Spacing size={24} />
                <Button theme="vk" primary sizeMode={ButtonSizeMode.big} onClick={handleClick}>
                    Увеличить место
                </Button>
            </div>
        </MobileDialog>
    );
});

MobileDisableDownloadPopup.displayName = 'MobileDisableDownloadPopup';
